<template>
  <v-container class="custom_conainer">
    <v-card height="600" width="256">
      <v-navigation-drawer permanent>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">
              <h6>Campaign Id- {{ $route.params.id }}</h6>
            </v-list-item-title>
            <v-list-item-subtitle>
              <div class="my-2">
                <v-btn small color="success" @click="openCreateModel"
                  >+ Add New</v-btn
                >
              </div>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list dense nav>
          <v-col cols="12" sm="12">
            <v-text-field label="Search Tiers" single-line></v-text-field>
          </v-col>
          <v-list-item v-for="item in data" :key="item.id" link>
            <v-list-item-icon>
              <v-icon small>mdi-layers-triple</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title @click="abc(item.id)"
                >{{ item.name }} </v-list-item-title
              ><v-divider></v-divider>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </v-card>
    <div class="content_area" v-if="tiersDetails">
      <v-row no-gutters>
        <v-col cols="12" sm="4">
          <v-card class="pa-2" outlined tile>
            Tier Name:
            <h6>{{ tier.name }}</h6>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4">
          <v-card class="pa-2" outlined tile>
            Weight:
            <h6>{{ tier.weight }}</h6>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4">
          <v-card class="pa-2" outlined tile>
            Boosted:
            <h6>{{ tier.is_boosted }}</h6>
          </v-card>
        </v-col>
      </v-row>
      <br />
      <v-divider></v-divider>
      <br />
      <TierPrize :tier_id='tier_id' />
    </div>

    <div v-else class="content_area1">
      <h4>----- No Tiers Selected ----</h4>
    </div>
    <TiersModel
      @openmodel="closeModel"
      v-if="tiersModal"
      :btnTitle="btn"
      :title="modalTitle"
      :item="itemData"
      @getTiers="getTiers"
      :deleteModal="showModelType"
      :prizing_id="prizing_id"
    ></TiersModel>
  </v-container>
</template>

<script>
import api from '@/clients/prizingapi/tiers'
import header from './tableColumns'
import { mapActions, mapGetters } from 'vuex'
import TierPrize from '@/pages/tier-prize/tier_prize'

export default {
  components: {
    TiersModel: () => import('./tiers-model'),
    TierPrize
  },
  data: () => ({
    tiersDetails: false,
    tier: {},
    data: [],
    tiersModal: false,
    modalTitle: ' ',
    btn: '',
    headers: header,
    itemData: [],
    showModelType: true,
    tier_id: '',
    prizing_id: ''
  }),
  mounted () {
    this.getTiers()
  },
  computed: {
    ...mapGetters({
      vg_activeBusinessBrandingAndLogo: 'auth/activeBusinessBrandingAndLogo'
    })
  },
  methods: {
    abc (event) {
      this.tier_id = event
      console.log('side id', this.tier_id)
      this.spinner(true)
      api
        .getTier(event)
        .then(res => {
          this.tier = res.data.payload
          this.tiersModal = false
          this.tiersDetails = true
          this.spinner(false)
        })
        .catch(error => {
          console.log(error)
          this.spinner(false)
          return error
        })
    },
    /**
     * To get a list of tiers
     * @function
     * @returns {object} - A promise that will either return an error message or perform an action.
     */
    getTiers () {
      this.spinner(true)
      api
        .getTierByPrizingId(this.$route.params.id)
        .then(res => {
          this.data = res.data.payload
          console.log('this.data', this.data)
          this.tiersModal = false
          this.spinner(false)
        })
        .catch(error => {
          console.log(error)
          this.spinner(false)
          return error
        })
    },
    /**
     * open Edit Model
     * @function
     */
    openEditModel (val) {
      this.modalTitle = 'Edit Tiers'
      this.btn = 'Update'
      this.tiersModal = true
      this.itemData = val
      this.showModelType = true
    },
    /**
     * open Create Model
     * @function
     */
    openCreateModel () {
      this.modalTitle = 'Create A Tiers '
      this.btn = 'Save'
      this.tiersModal = true
      this.prizing_id = this.$route.params.id
      this.showModelType = true
    },
    /**
     * open Delete Model
     * @function
     */
    opendeleteModel (val) {
      this.modalTitle = 'Delete Tiers '
      this.btn = 'Delete'
      this.tiersModal = true
      this.itemData = val
      this.showModelType = false
    },
    /**
     * set value of TiersModel False
     * @function
     */
    closeModel () {
      this.tiersModal = false
    },
    ...mapActions({
      va_setActiveBusinessBranding: 'auth/setActiveBusinessBranding'
    })
  }
}
</script>

<style lang="scss" scoped>
.custom_conainer {
  width: 100%;
  max-width: 100%;
  display: flex;
  align-items: self-start;
  height: 100%;
  justify-content: start;
}
.content_area {
  margin-left: 20px;
  width: 100%;
}
.content_area1 {
  margin-left: 20px;
  width: 100%;
    justify-content: center;
    display: flex;
    align-items: center;
    height: 100%;
}
.v-list--dense .v-list-item .v-list-item__icon{margin-right: 0;}
</style>
